import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import {
  Cancel as CancelIcon,
  AccessTime as AccessTimeIcon,
  Alarm as AlarmIcon,
} from '@mui/icons-material';
import { ProspectPipelineTimeline } from './ProspectPipelineTimeline';

interface PipelinePreviewCardProps {
  pipeline: any;
  onOpenStream?: (streamUuid: string) => void;
}

export const PipelinePreviewCard: React.FC<PipelinePreviewCardProps> = ({ 
  pipeline,
  onOpenStream,
}) => {
  return (
    <Box
      sx={{
        p: 1.5,
        border: 1,
        borderColor: pipeline.status === 'Failed' ? 'error.light' : 'divider',
        borderRadius: 1,
        bgcolor: pipeline.status === 'Failed' ? 'error.50' : undefined,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
        {pipeline.pipeline?.name || pipeline.name}
      </Typography>
      
      <Stack spacing={1}>
        {/* Status and Step */}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {pipeline.status && (
            <Chip 
              size="small" 
              label={pipeline.status}
              color={pipeline.status === 'Failed' ? 'error' : pipeline.status === 'Done' ? 'success' : 'default'}
            />
          )}
          {pipeline.step?.name && (
            <Chip size="small" label={pipeline.step.name} variant="outlined" />
          )}
          {pipeline.failed_reason && (
            <Chip size="small" icon={<CancelIcon />} label={pipeline.failed_reason} color="error" />
          )}
        </Box>
        
        {/* Step Categories */}
        {(pipeline.step_categories || []).length > 0 && (
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
            <Typography variant="caption" color="text.secondary">Categories:</Typography>
            {pipeline.step_categories.slice(0, 5).map((sc: string) => (
              <Chip key={sc} size="small" label={sc} variant="outlined" />
            ))}
          </Box>
        )}
        
        {/* Dates */}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {pipeline.started_at && (
            <Chip icon={<AccessTimeIcon />} size="small" label={`Started: ${new Date(pipeline.started_at).toLocaleDateString()}`} variant="outlined" />
          )}
          {pipeline.available_at && (
            <Chip icon={<AlarmIcon />} size="small" label={`Available: ${new Date(pipeline.available_at).toLocaleDateString()}`} variant="outlined" />
          )}
        </Box>
        
        {/* Project/Stream */}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {pipeline.stream?.key && onOpenStream && (
            <Chip size="small" label={pipeline.stream.name} onClick={() => onOpenStream(pipeline.stream.key)} />
          )}
        </Box>

        {/* Timeline */}
        <ProspectPipelineTimeline timeline={pipeline.timeline} />
      </Stack>
    </Box>
  );
};


